import * as React from 'react';

import { LoadingLabel } from './elements';

export const LoadingState: React.FC = () => {
  return <LoadingLabel label="Loading..." />;
};
